import levenshtein from 'js-levenshtein';
import type { Fields } from '../../../types';

type AutoMatchAccumulator<T> = {
  distance: number;
  value: T;
};

export const findMatch = <T extends string>(
  header: string,
  fields: Fields<T>,
  autoMapDistance: number,
  matcherIgnorePrefixes?: string[]
): T | undefined => {
  // Use matcher ignore prefixes to ignore irrelevant header prefixes.
  matcherIgnorePrefixes?.find((prefix) => {
    if (header.startsWith(prefix)) {
      header = header.replace(prefix, '');
      return true;
    }
    return false;
  });

  const smallestValue = fields.reduce<AutoMatchAccumulator<T>>(
    (acc, field) => {
      const distance = Math.min(
        ...[
          levenshtein(field.key as string, header),
          ...(field.alternateMatches?.map((alternate) => {
            // Use matcher ignore prefixes to ignore irrelevant field prefixes.
            matcherIgnorePrefixes?.find((prefix) => {
              if (alternate.startsWith(prefix)) {
                alternate = alternate.replace(prefix, '');
                return true;
              }
              return false;
            });

            return levenshtein(alternate, header);
          }) || [])
        ]
      );
      return distance < acc.distance || acc.distance === undefined
        ? ({ value: field.key, distance } as AutoMatchAccumulator<T>)
        : acc;
    },
    {} as AutoMatchAccumulator<T>
  );
  return smallestValue.distance <= autoMapDistance ? smallestValue.value : undefined;
};
